import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { BackendService } from '../../core/backend.service';
import { EquipmentFunctionModelSelectionCriteriaBase } from '../../viewmodels/equipment/equipment-function-model-selection-criteria-base';
import { FailureRateSelectionCriteria } from '../../viewmodels/equipment/failure-rate-selection-criteria';
import { OptimizationFailureRateOption } from '../../viewmodels/equipment/optimization-failure-rate-option';
import { IsoHierarchyQueryBaseService } from './iso-hierarchy-query-base.service';

@Injectable({
  providedIn: 'root',
})
export class FailureRateSelectionService extends IsoHierarchyQueryBaseService {
  existingCriteria: FailureRateSelectionCriteria;
  selectedFailureRate = new Subject<OptimizationFailureRateOption>();

  constructor(private backendService: BackendService) {
    super();
  }

  selectData(criteria: FailureRateSelectionCriteria) {
    this.selectedFailureRate.next(criteria.searchResult.foundFailureRates[0]);
  }

  createCriteria(): EquipmentFunctionModelSelectionCriteriaBase {
    if (this.existingCriteria) {
      return this.existingCriteria;
    }

    const criteria = new FailureRateSelectionCriteria();
    criteria.requiresFunctions = true;
    criteria.excludedModelIds = this.excludedDataIds;

    return criteria;
  }

  findData(criteria: FailureRateSelectionCriteria): Observable<EquipmentFunctionModelSelectionCriteriaBase> {
    criteria.searchResult = null;
    return this.backendService.create(FailureRateSelectionCriteria, criteria, false);
  }

  isExistingCriteriaValid(): boolean {
    return this.validateCriteria(this.existingCriteria);
  }
}
